export { default } from './Home24Blog';
